import api from './api';

export const listNotifications = async () => {
  const { data } = await api.get('/notifications');
  return data;
};

export const createNotification = async (payload) => {
  const { data } = await api.post('/notifications', payload);
  return data;
};

export const markNotificationRead = async (id) => {
  const { data } = await api.post(`/notifications/${id}/read`);
  return data;
};

export default {
  listNotifications,
  createNotification,
  markNotificationRead,
};
